import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faCopy,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {
  openDeleteNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { Tooltip } from "antd";
import { hasRole } from "../../../global/hooks/getUserRole";

export const MysiteColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  setModal,
  columnsValues
) => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const token = userData ? userData?.access_token : null;

  const navigate = useNavigate();
  //const { role_value } = userData;
  const role_value = userData?.role_value;
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const isColumnVisible = (columnKey) => {
    return columnsValues?.includes(columnKey);
  };

  const getSingleSite = async (siteNo) => {
    // console.log("getSingleSite called with siteNo:", siteNo);
    try {
      if (!token) {
        navigate("/");
        return;
      }
      const url = `${process.env.REACT_APP_API_URL}/api/sites/${siteNo}/`;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios({
        method: "GET",
        url,
        headers,
      });

      return response?.data;
      // setProfile(response.data.data);
    } catch (error) {
      console.error("Error fetching site details:", error);
      navigate("/site");
    }
  };

  const handleGoto = async (e, record, Link) => {
    // console.log("handleGoto called with record:", record);
    e.stopPropagation();
    const dynamicUrl = `${process.env.REACT_APP_API_URL}/api/sites/site-cgi/`;
    try {
      // if (record.SiteType === "RMC") {
      const response = await fetch(dynamicUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          DeviceNo: record?.DeviceNo,
          SiteKey: record?.SiteKey,
        }),
      });

      const respon = await response.json();
      if (respon?.message === "Site is blocked currently.") {
        return setModal(respon);
      }

      // }
      const res = await getSingleSite(record?.DeviceNo);
      // console.log("Response from getSingleSite:", res);
      let link = res?.data?.Link;
      if (link) {
        // Open the link in a new tab
        setTimeout(() => {
          window.open(link, "_blank");
        }, 1500);
      } else {
        openErrorNotification("No link found for this site.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCopy = async (e, record, text) => {
    e.stopPropagation();
    // const dynamicUrl = `${process.env.REACT_APP_API_URL}/api/sites/site-cgi/`;
    try {
      // const response = await fetch(dynamicUrl, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json; charset=utf-8",
      //   },
      //   body: JSON.stringify({
      //     DeviceNo: record?.DeviceNo,
      //     SiteKey: record?.SiteKey,
      //   }),
      // });

      // await response.json();
      // const res = await getSingleSite(record?.DeviceNo);
      // let link = res?.data?.Link;
      if (!text) {
        openErrorNotification("No site key found for this site.");
        return;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (
      navigator?.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      // Primary method: Using Clipboard API
      navigator.clipboard
        .writeText(text)
        .then(() => {
          openDeleteNotification("Success");
          // showToast("Copied to clipboard.!!", "success", <FaCheckCircle />);
        })
        .catch((error) => {
          console.error("Clipboard API failed:", error);
          openErrorNotification("Failed to copy.");
          // showToast("Failed to copy.", "error", <FaTimesCircle />);
        });
    } else {
      // Fallback method: Using document.execCommand
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed"; // Prevent scrolling to bottom of the page
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        if (document.execCommand("copy")) {
          // showToast("Copied to clipboard.!!", "success", <FaCheckCircle />);
          openDeleteNotification("Success");
        } else {
          throw new Error("execCommand failed");
        }
        document.body.removeChild(textArea);
      } catch (error) {
        console.error("Fallback copy failed:", error);
        openErrorNotification("Failed to copy.");
        // showToast("Failed to copy.", "error", <FaTimesCircle />);
      }
    }
  };

  return [
    {
      title: "No",
      dataIndex: "DeviceNo",
      key: "DeviceNo",
      width: 80,
      hidden: !isColumnVisible("DeviceNo"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: 150,
      hidden: !isColumnVisible("DeviceName"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () => {
          return setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceName",
            order: modParams.order === "desc" ? "asc" : "desc",
          }));
        },
      }),
    },
    {
      title: "Description",
      dataIndex: "DeviceDesc",
      key: "DeviceDesc",
      hidden: !isColumnVisible("DeviceDesc"),
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    ...(hasRole(1, 2, 3)
      ? [
          {
            title: "OEM",
            dataIndex: "Oem",
            key: "Oem",
            width: 150,
            hidden: !isColumnVisible("Oem"),
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey={"OemNo"}
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams({
                  ...modParams,
                  sort_by: "OemNo",
                  order: modParams.order === "desc" ? "asc" : "desc",
                }),
            }),
          },
        ]
      : []),
    ...(hasRole(1, 2, 3, 4, 5, 6)
      ? [
          {
            title: "Dealer",
            dataIndex: "Dealer",
            key: "Dealer",
            width: 150,
            hidden: !isColumnVisible("Dealer"),
            render: (text, record) => {
              return record?.Dealer ? text : "Guest";
            },
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey={"DealerNo"}
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams({
                  ...modParams,
                  sort_by: "DealerNo",
                  order: modParams.order === "desc" ? "asc" : "desc",
                }),
            }),
          },
        ]
      : []),
    {
      title: "Customer",
      dataIndex: "Customer",
      key: "Customer",
      width: 150,
      hidden: !isColumnVisible("Customer"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey={"CustomerNo"}
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "CustomerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Site Type",
      dataIndex: "SiteType",
      key: "SiteType",
      width: 150,
      hidden: !isColumnVisible("SiteType"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="SiteType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "SiteType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      hidden: !isColumnVisible("Mac"),
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Mac"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Mac",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "RMC",
    //   dataIndex: "RMC",
    //   key: "RMC",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="RMC"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "RMC",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Version",
      dataIndex: "Version",
      key: "Version",
      width: 100,
      hidden: !isColumnVisible("Version"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Version"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Version",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
      width: 150,
      hidden: !isColumnVisible("Address"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Address"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Address",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Online",
      dataIndex: "Online",
      key: "Online",
      width: 100,
      hidden: !isColumnVisible("Online"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Online"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Online",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      // render: (_, data) => (data.Online === 0 ? "No" : "Yes"),
    },
    {
      title: "Blocked",
      dataIndex: "Blocked",
      key: "Blocked",
      hidden: !isColumnVisible("Blocked"),
      width: 100,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Blocked"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Blocked",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Site Key",
      dataIndex: "SiteKey",
      key: "SiteKey",
      width: 300,
      hidden: !isColumnVisible("SiteKey"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="SiteKey"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "SiteKey",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Link",
      fixed: "right",
      // width: 100,
      align: "left",
      className: "customTablecss",
      render: (text, record, rowIndex) => {
        // console.log(record?.Online);
        return (
          <div className="ml-2">
            <div className="duration-75 bottom-0 flex gap-2 items-center  z-50">
              <Tooltip title="Go To">
                <button
                  className="hover:bg-gray-400 group px-[5px] py-1 rounded-[4px] mr-1 disabled:cursor-not-allowed disabled:opacity-50"
                  onClick={(e) => handleGoto(e, record, Link)}
                  disabled={
                    record?.Online === "No" ||
                    !["RMC", "RMC Plus", "Cloud", "Virtual"].includes(
                      record?.SiteType
                    )
                  }
                >
                  <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className=" group-hover:text-[#636262ee]"
                  />
                </button>
              </Tooltip>
              <Tooltip title="Copy">
                <button
                  className="hover:bg-gray-400 group disabled:cursor-not-allowed disabled:opacity-50 px-[5px] py-1 rounded-[4px] mr-1 "
                  onClick={(e) => {
                    handleCopy(
                      e,
                      record,
                      `${window.location.origin}/api/sitelink?sitekey=${record?.SiteKey}`
                    );
                  }}
                  disabled={
                    record?.Online === "No" ||
                    !["RMC", "RMC Plus", "Cloud", "Virtual"].includes(
                      record?.SiteType
                    )
                  }
                >
                  <FontAwesomeIcon
                    icon={faCopy}
                    className="group-hover:!text-[#50565e]"
                  />
                </button>
              </Tooltip>
              {/* {[0, 1, 2, 6, 7, 8].includes(role_value) && (
                <Tooltip title="Edit">
                  <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                    <Link
                      to={`/site/edit/${record?.DeviceNo}`}
                      onClick={(e) => e.stopPropagation()}
                      className=" hover:text-[#636262ee]"
                    >
                      <FontAwesomeIcon
                        icon={faEdit}
                        className="!text-[#50565e]"
                      />
                    </Link>
                  </div>
                </Tooltip>
              )} */}
            </div>
          </div>
        );
      },
      // hoveredRow === rowIndex ? (
      // ) : null,
    },
  ];
};
